import React, { useEffect, useState } from "react";
import { Form, message, Skeleton } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch } from "@comps/components"
import { makeRequest } from "@utils/helpers";
import { updateDataReq } from "../requests";
import { Commons, Const } from "../../constants";

const langKey = Const["servers"].lngKey
const formName = "servers";

const UpdateServer = (props) => {
  const [loader, setLoader] = useState(false);
  const [loading, setloading] = useState(false);
  const [form] = Form.useForm();
  //for color picker

  useEffect(() => {
    if (props.record === undefined) return
    form.setFieldsValue(props.record)
    form.setFieldValue("active", props.record.active ? 1 : 0)
    form.setFieldValue("prod", props.record.prod ? 1 : 0)
  }, [props, form])

  const onSubmit = (data) => {
    const payload = { ...props.record, ...data }
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    message.success("Saved successfully");
    props.onCompleted(data)
  }

  const onError = (err, res) => {
    console.error(err);

  }
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    !props.disabled &&
    <SaveButton loading={ loader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 800 } maskClosable={ false }
      mainTitle={ trans(Commons.update) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form form={ form } { ...formLayout } name={ formName } onFinish={ onSubmit } disabled={ props.disabled } scrollToFirstError>

          <Form.Item name="name" rules={ rules.name } label={ trans(`${langKey}.name`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.name`) } disabled />
          </Form.Item>

          <Form.Item name="ip" rules={ rules.ip } label={ trans(`${langKey}.ip`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.ip`) } />
          </Form.Item>

          <Form.Item name="domain" rules={ rules.domain } label={ trans(`${langKey}.domain`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.domain`) } />
          </Form.Item>

          <Form.Item name="rabbitmqDomain" rules={ rules.rabbitmqDomain } label={ trans(`${langKey}.rabbitmqDomain`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.rabbitmqDomain`) } />
          </Form.Item>

          <Form.Item name="active" rules={ rules.active } label={ trans(`${langKey}.active`) }
            className="da-mb-16"
          >
            <SelectWithSearch options={ [
              { label: "Yes", value: 1 }, { label: "No", value: 0 }
            ] } placeholder={ trans(`${langKey}.active`) } />
          </Form.Item>

          <Form.Item name="prod" rules={ rules.prod } label={ trans(`${langKey}.prod`) }
            className="da-mb-16"
          >
            <SelectWithSearch options={ [
              { label: "Yes", value: 1 }, { label: "No", value: 0 }
            ] } placeholder={ trans(`${langKey}.prod`) } />
          </Form.Item>

          <Form.Item name="noOfSaas" rules={ rules.noOfSaas } label={ trans(`${langKey}.noOfSaas`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.noOfSaas`) } />
          </Form.Item>
        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default UpdateServer

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name`) },
  ],
  ip: [
    { required: true, message: trans(`${langKey}.ip`) },
  ],

  domain: [
    { required: true, message: trans(`$rules${langKey}.domain`) },
  ],

  rabbitmqDomain: [
    { required: true, message: trans(`$rules${langKey}.rabbitmqDomain`) },
  ],

  active: [
    { required: true, message: trans(`$rules${langKey}.active`) },
  ],
  prod: [
    { required: true, message: trans(`${langKey}.prod`) },
  ],
  noOfSaas: [
    { required: true, message: trans(`${langKey}.noOfSaas`) },
  ],
};

const formLayout = {
  layout: "horizontal",
  labelCol: { span: 6 },
  // wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}